import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cd, disc, vinyl, dvd, dj, spin, music, album"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M10.9991 6.08301C8.48657 6.50453 6.50355 8.48754 6.08203 11M17.9161 13C17.4946 15.5125 15.5116 17.4956 12.999 17.9171" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="2.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCd;
